import { IHavainnotFormSchema } from "../interfaces/IFormSchema";
import { JSONSchema, JSONSchemaDefinition } from "../schema/RJSF";


/**
 * Loops trough each schema property
 * @param properties 
 * @param invoke 
 * @param pathBase 
 */
export const forEachSchemaProp = (
    properties: JSONSchema["properties"],
    invoke: (path: string, prop: JSONSchemaDefinition) => void,
    pathBase?: string
) => {
    if (!properties) { return };

    Object.keys(properties).forEach((key) => {
        const prop = properties[key];
        if (prop === true || prop === false) { return };

        if (prop.type === "object") {
            forEachSchemaProp(prop.properties, invoke, key);
            return
        }

        const path = pathBase ? [pathBase, key].join(".") : key;
        invoke(path, prop);
    });
};


/**
 * Loops trough each schema property
 * @param properties 
 * @param invoke 
 * @param pathBase 
 */
export const getInstructionDocumentHrefs = (schema: IHavainnotFormSchema) => {
    let documentHrefs: Array<string> = [];

    forEachSchemaProp(schema.schema.properties as any, (path) => {
        const uiProps = schema.uiSchema[path] || {};
        const options = uiProps["ui:instruction"];
        const instructionWidget = uiProps["ui:widget"] === "instruction";
        if (instructionWidget && options) {
            documentHrefs = documentHrefs.concat(options.href)
        }

    });

    return documentHrefs;
};
